import { Col, Input, Row } from "antd";
import React from "react";
import SelectLayout from "../../../../components/SelectLayout";
import SearchDate from "../../../../components/SearchDate";
import SelectBranch from "./SelectBranch";
import SelectStatus from "./SelectStatus";
import _ from "lodash";
import { useEffect } from "react";
import { useMemo } from "react";
import { useRef } from "react";
import { getUser } from "../../../../utils";

const SearchDocument = ({
  searchOption,
  setSearchOption,
  fetchDataListWithParams,
}) => {
  const isFirstRender = useRef(true);
  const user = useMemo(() => getUser(), []);
  const debounceSearch = useMemo(
    () =>
      _.debounce((option) => {
        fetchDataListWithParams(option);
      }, 300),
    [fetchDataListWithParams],
  );

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    debounceSearch(searchOption);

    return () => {
      debounceSearch.cancel();
    };
  }, [searchOption, debounceSearch]);

  return (
    <Row gutter={[8, 8]} type="flex" className="align-items-center mb-3">
      <Col span={24} xl={10} xxl={7}>
        <Input.Search
          allowClear
          placeholder="รหัสพนักงาน, ชื่อพนักงาน"
          autoComplete="off"
          value={searchOption.search}
          onChange={(e) =>
            setSearchOption({ ...searchOption, search: e.target.value })
          }
        />
      </Col>
      <Col span={24} xl={7} xxl={5}>
        <SelectLayout title="สาขาผู้ขอเบิก">
          <SelectBranch
            value={
              user?.department_id === 1
                ? searchOption.branchCode
                : (user?.branch_code ?? "")
            }
            onChange={(branchCode) =>
              setSearchOption({ ...searchOption, branchCode })
            }
          />
        </SelectLayout>
      </Col>
      <Col span={24} xl={7} xxl={5}>
        <SelectLayout title="สถานะ">
          <SelectStatus
            value={searchOption.flowStatus}
            onChange={(flowStatus) =>
              setSearchOption({ ...searchOption, flowStatus })
            }
          />
        </SelectLayout>
      </Col>
      <Col span={24} xl={14} xxl={7}>
        <SearchDate
          title="วันที่คำขอ"
          start={searchOption.startDate}
          end={searchOption.endDate}
          onChangeStart={(date) =>
            setSearchOption({ ...searchOption, startDate: date })
          }
          onChangeEnd={(date) =>
            setSearchOption({ ...searchOption, endDate: date })
          }
        />
      </Col>
    </Row>
  );
};

export default SearchDocument;
